<template>
  <div class="component-container">
    <h3>5PNG Structure and Properties of Matter (Second Edition) - Downloads and Resources</h3>
    <div class="back-button-wrapper">
      <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
    </div>
    <div class="presentations">
      <h4>Teacher Presentations</h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2F5PNG-2E_Activities_1-4_08272024.zip?alt=media&token=27d49b9f-046e-404e-95b4-ddacf8bca801" target="_blank">Teacher Presentations: Activities 1 - 4</a> - Updated 8/27/2024</li>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2F5PNG-2E_Activities_5-6_09242024.zip?alt=media&token=a616e2f5-b83d-4e45-8e52-d31d0080e8a9" target="_blank">Teacher Presentations: Activities 5 & 6</a> - Updated 9/24/2024 (Added missing video for Lesson 6C)</li>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2F5PNG-2E_Activities_7-8_09242024.zip?alt=media&token=3864160b-bde9-499d-8370-32484d39e95b" target="_blank">Teacher Presentations: Activities 7 & 8</a> - Updated 9/24/2024</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
    </div>
    <div class="presentations">
      <h4>2nd Edition Student Journals</h4>
      <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
      <ul>
        <li><a href="https://docs.google.com/presentation/d/1JRF22tRlDj85vc4jxxzmwNSzagAv-7yPznu9NhBj1dc/copy" target="_blank">5PNG Structure and Properties of Matter (Second Edition) - Student Journal</a></li>
        <li><a href="https://drive.google.com/file/d/1f2NelCnVUf_xxcfHcDTin0JTz4AhWHCY/view" target="_blank">5PNG Structure and Properties of Matter (Second Edition) - Student Journal Answer Key</a></li>
        <li><a href="https://docs.google.com/presentation/d/1Bapvo-GDUXbHZZN4khj4at5_oOp_5R50Ki2oUuPH9ck/copy">5PNG Structure and Properties of Matter (Second Edition) - Spanish Student Journal</a></li>
      </ul>

    </div>
    <div class="presentations">
      <h4>Individual Resources</h4>
      <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/pdf%2F5PNG2E_WheresTheSkunk_Booklet.pdf?alt=media&token=1810cc54-2f36-4b3f-a427-00098687f43b" target="_blank">Where's the Skunk?</a></li>
          <li><a href="https://docs.google.com/presentation/d/1YU4Ppxj1DfPN0fv_062bqlrK6wTahBnBQgzsfX9f4n8/copy" target="_blank">Anchor Posters</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Re3icY-Uu3FoEDSjK8Am1l-rLWeIHWDXnQpnsABaDt4/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1dx__OZkgaEiXOpEsBIcmiridOxmUDmcTPDJNFF83DfM/copy" target="_blank">Word Wall</a></li>
          <li><a href="https://docs.google.com/presentation/d/1RiGJ2WF6xdTvirykU3eAxvRPbv_TIq1ejaFSLwhcM1A/copy" target="_blank">Word Sort Cards - Lesson 2B</a></li>
          <li><a href="https://docs.google.com/presentation/d/1EzWaSQJMYM7r8dzEcEeeCv2N-SeKZKNGFqC-DWoz_-0/copy" target="_blank">Word Sort Cards - Lesson 4C</a></li>
          <li><a href="https://docs.google.com/presentation/d/11-BHBc57LQ2ViuuaeAG_qcCpuV2kl-kSsI-yGOdDRlg/copy" target="_blank">Room Temperature Data Chart - Lesson 5A</a></li>
          <li><a href="https://docs.google.com/presentation/d/15mOUXd3D5Yd5AIeG2dOW3I2IBxv6PpvwrfgreNmR4QU/copy" target="_blank">Skunk Odor Card Set - Lesson 5B</a></li>
          <li><a href="https://docs.google.com/presentation/d/1-921Dyqq3UBNJ3YUfp1oralY6CM1GKjZaj1vUrXTFls/copy" target="_blank">Word Sort Cards - Lesson 6D</a></li>
          <li><a href="https://docs.google.com/presentation/d/1zXEKLJSHK33MJSZXFc-oYZjUJX_qDYc2sSxDKmLh29Q/copy" target="_blank">Save Our Treats Product Descriptor</a></li>
          <li><a href="https://docs.google.com/presentation/d/1gUdWWn9AwD3KgwsHJolRjjBQsOiWpjibEEKwEGubjqg/copy" target="_blank">Word Sort Cards - Lesson 8B</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->
        </ul>

        <h4 style="margin-left: 10px;">Videos</h4>
        <ul>
          <li><a href="https://drive.google.com/file/d/1n3M_mD9X4DaZv_drVSZ05SdXueIx8rbI/view?usp=sharing" target="_blank">Boiling Water Investigation Video</a></li>
          <li><a href="https://drive.google.com/file/d/1f3RhI_DfOJh0QRkiS37Z5JBE23zzJ-2Z/view?usp=sharing" target="_blank">Mixing Kool-Aid</a></li>
          <li><a href="https://drive.google.com/file/d/1fgisQggxhCcrdLOtsmNIVqJbU1OFBXBZ/view?usp=sharing" target="_blank">Sugar and Water Investigation</a></li>
          <li><a href="https://drive.google.com/file/d/1dfk-kIoZ0k4netcMDP8MrzYInw-_Dz8D/view?usp=sharing" target="_blank">Solubility Investigations</a></li>
          <li><a href="https://drive.google.com/file/d/1QmOXl4gk2bkiu5xozmx90ZcL8ykEhYPR/view?usp=sharing" target="_blank">Effect of Temperature on Solubility</a></li>
          <li><a href="https://drive.google.com/file/d/1hJFOUxQOXtq4BNOnOCg7GakdDhphrmQ-/view?usp=sharing" target="_blank">Video of Melting Chocolate in a Hand</a></li>
          <li><a href="https://drive.google.com/file/d/1MAt436iRHnfJclnn7ACSr8cpwe3wH0yv/view?usp=sharing" target="_blank">Heat Conduction</a></li>
          <li><a href="https://drive.google.com/file/d/1HmRTXJdR3DM0ZVWwyWfKFF4HOPrgFXRT/view?usp=sharing" target="_blank">Electric Conductivity</a></li>
          <li><a href="https://drive.google.com/file/d/1-E6xR1_PHBiR16-vZu65FnnnCrCf16fU/view?usp=sharing" target="_blank">Magnetism</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->
        </ul>
      
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="css" scoped>
.presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
}
ul {
  list-style: none;
}
.presentations a {
  margin-left: 40px;
}
li {
  margin-left: -40px;
}
.back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
}
.back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
}
</style>
